import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Markdown from 'markdown-to-jsx';
import { Breadcrumb } from 'semantic-ui-react';

import { GatsbyImagePropType } from '../../services/proptypes';
import Image from '../../atoms/Image';
import Link from '../../atoms/Link';
import { BlogPostSchema } from '../../darkmatter/SEO';
import { formatAuthor } from './BlogPost.presenters';

import './BlogPost.css';

export default class BlogPost extends React.PureComponent {
  getHeaderText() {
    const { publishedAt, author } = this.props;

    const authorString = formatAuthor(author);

    let headerParts = publishedAt ? [moment(publishedAt).format('LL')] : [];
    if (author) {
      headerParts = [authorString, ...headerParts];
    }

    return headerParts.join(' | ');
  }

  getContent() {
    const { content, markdown } = this.props;
    return markdown ? <Markdown>{content}</Markdown> : content;
  }

  createSchemaProps() {
    const { author, publishedAt, heroImage } = this.props;

    return {
      ...this.props,
      datePublished: publishedAt,
      author: formatAuthor(author),
      // TODO remove when upgrading node version, replace with optional chaining
      heroImage: heroImage && heroImage.fluid && heroImage.fluid.src,
    };
  }

  render() {
    const { title, heroImage, markdown } = this.props;

    return (
      <div>
        <BlogPostSchema {...this.createSchemaProps()} />

        <Breadcrumb className="blog-post-breadcrumbs">
          <Breadcrumb.Section as={Link} title="Blog" to="/blog" />
          <Breadcrumb.Divider icon="right chevron" />
          <Breadcrumb.Section>{title}</Breadcrumb.Section>
        </Breadcrumb>

        <article>
          <header>
            <h1>{title}</h1>
            {heroImage && <Image src={heroImage} className="blog-post-image" />}
            <h4>{this.getHeaderText()}</h4>
          </header>
          <section
            className={`blog-post-content-section ${markdown ? '' : 'white-space-line-break'}`}
          >
            {this.getContent()}
          </section>
        </article>
      </div>
    );
  }
}

BlogPost.propTypes = {
  title: PropTypes.string.isRequired,
  publishedAt: PropTypes.string.isRequired,
  author: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    avatar: PropTypes.string,
    email: PropTypes.string,
  }),
  heroImage: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
  content: PropTypes.string.isRequired,
  markdown: PropTypes.bool,
  summary: PropTypes.string,
};

BlogPost.defaultProps = {
  heroImage: null,
  author: null,
  markdown: false,
  summary: '',
};
